class CountryValidation {
	setDomElements(e) {
		this.countrySelectionForm = e.target.closest('.country-selection');

		this.countrySelect = this.countrySelectionForm?.querySelector(
			'.country-selection__select',
		);
	}

	listeners() {
		if (document.querySelector('.js-input-validation-wrapper')) {
			document.addEventListener('change', e => {
				this.setDomElements(e);
				this.countrySelectionForm?.submit();
			});
		}
	}

	init() {
		this.listeners();
	}
}

export default CountryValidation;
